<template>
    <div v-wechat-title="title" class="padding10">
        <el-row type="flex" align="middle">
            <el-col :md="6" :xl="5">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
            <el-col :md="4" :xl="3">
                <item-input type="select" v-model="print_status" :options="print" placeholder="打印状态" clearable></item-input>
            </el-col>
            <el-col :md="4" :xl="3">
                <item-input type="select" v-model="needPrintDrugType" :options="needPrintDrugTypeoptions" placeholder="处方类型" clearable></item-input>
            </el-col>
            <el-col :md="4" :xl="3">
                <item-input type="string" :readonly="!isHaveSearchotheranesdoctor" placeholder="麻醉医生" v-model="searchValue"></item-input>
            </el-col>
            <el-col :md="4" :xl="3">
                <item-input v-if="!prescriptionDrugs || prescriptionDrugs.trim() == `` || prescriptionDrugs.trim() == `0`" type="string" v-model="drugName" placeholder="药品名称"></item-input>
                <item-input v-else type="select" :allowCreate="true" v-model="drugName" :options="drugList" placeholder="药品名称" clearable></item-input>
            </el-col>
            <el-col :md="11" :xl="15" class="align-right">
                <el-button type="primary" size="mini" @click="ExportExcel">导出<i class="el-icon--right"></i></el-button>
                <el-dropdown @command="printDrug">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="drugType in needPrintDrugTypeoptions" :key="drugType.value" v-text="drugType.label" :command="drugType"></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
            <!-- <el-col :md="11" :xl="15" class="align-right">
                <el-button type="primary" size="mini" @click="SyncUseDrug">同步</el-button>
                <el-button type="primary" size="mini" v-if="this.cffsBtnName != '0'" @click="SendCheckedToHis">{{ this.cffsBtnName }}</el-button>
                <el-button type="primary" size="mini" @click="loadPrescriptions">刷新</el-button>
                <el-button type="primary" size="mini" @click="loadFactorInfo">代办人信息</el-button>
                <el-dropdown @command="printDrugPreview" v-if="isCanPreViewPrescription == '1'">
                    <el-button type="primary" size="mini">打印预览<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="drugType in needPrintDrugTypeYuLan" :key="drugType.value" v-text="drugType.label" :command="drugType"></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printDrug" v-else>
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="drugType in needPrintDrugType" :key="drugType.value" v-text="drugType.label" :command="drugType"></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" size="mini" @click="saveDrug">保存</el-button>
            </el-col> -->
        </el-row>
        <list-view
            :showSequence="true"
            :selection="true"
            ref="prescription-list"
            :datalist="datalist"
            :tableHeight="this.screenHeight - 186"
            @extrabutton-click="ExtraButtonClick"
            :columns="columnList"
            :buttons="[]"
            :reserveSelection="false"
        >
            <!-- <template slot="send_state" slot-scope="{ row }">
                <p :title="titleLabel(row)" :style="getstateStyle(row)">
                    {{ row.send_state }}
                </p>
            </template> -->
        </list-view>
        <el-pagination class="align-left" background layout="total, sizes, prev, pager, next, jumper" @size-change="loadPrescriptions"
            @current-change="loadPrescriptions" :page-sizes="[10, 20, 50, 100, 200]" :current-page.sync="currentPage"
            :page-size.sync="pageSize" :total="total">
        </el-pagination>
    </div>

    <!-- <crud-facecade
        ref="surgerylog-list"
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :addButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >

    </crud-facecade> -->
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `PrescriptionManage`,
    props: {

    },
    data() {
        return {
            title: `处方管理`,
            currentPage: 1,
            pageSize: 50,
            total: 0,
            messageList: [],
            print_status: undefined,
            needPrintDrugType: undefined,
            datalist: [],
            searchValue: null,
            drugName: null,
            ischecked: false,
            print: [
                {
                    value: `已打印`,
                    label: `已打印`
                },
                {
                    value: `未打印`,
                    label: `未打印`
                }
            ],
            invalidPrescriptionConfig: this.$root.InvalidPrescriptionConfig,
            getPrescriptionProc: this.$root.GetPrescriptionProc,
            prescription_status: [
                { value: 0, label: `` },
                { value: -1, label: `已作废` }
            ],
            buttons: [],
            // rdate: [this.$moment().add(-0, `days`).format(`YYYY/MM/DD`), this.$moment().add(0, `days`).format(`YYYY/MM/DD HH:mm:ss`)],
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD HH:mm:ss`)],
            users: [],
            drugList: [],
            prescriptionDrugs: this.$root.PrescriptionDrugs
        }
    },
    created() {
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadPrescriptions()
        if (this.prescriptionDrugs && this.prescriptionDrugs.trim() != `` && this.prescriptionDrugs.trim() != `0`) {
            this.drugList = this.prescriptionDrugs.trim().split(`；`).map(x => {
                return {
                    label: x,
                    value: x
                }
            }).filter(t => t.value && t.value.trim() != ``)
        } else {
            this.drugList = []
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `business`, `localip/ipAddress`, `active_ward`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `currentUser`, `screenHeight`, `screenWidth`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `permissions`]),
        dic_ward_id: {
            get: function() {
                if (this.active_ward && this.active_ward.code == `手术区`) {
                    return this.active_ward.origion
                }
            },
            set: function(v) {

            }
        },
        needPrintDrugTypeoptions() {
            let drugTypes = _.filter(this[`drug/drug_type`], { IsPrescription: true })
            return drugTypes
        },
        isHaveSearchotheranesdoctor() {
            console.log(this.permissions.findIndex(item => item.permission === `prescription:searchanesdoctor`))
            console.log(this.permissions.findIndex(item => item.permission === `prescription:searchanesdoctor`))
            let r = this.permissions && this.permissions.findIndex(item => item.permission === `prescription:searchanesdoctor`) != -1

            return r
        },
        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    sortable: true,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_drug_name`,
                    label: `药品全称`,
                    width: `300`,
                    isListable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    isListable: true
                },
                {
                    type: `integer`,
                    prop: `amount`,
                    label: `数量`,
                    isListable: true,
                    queryable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `total_dose`,
                    label: `实际用量`,
                    width: `100`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    decimal_places: 2,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `surplus_dose`,
                    label: `剩余量`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    options: _.map(this[`drug/drug_unit`], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `add_drug_way`,
                    label: `给药途径`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    options: _.map(this[`drug/drug_way`], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `batch_no`,
                    label: `批号`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `dic_drug_type_id`,
                    label: `药品类型`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    options: this[`drug/drug_type`],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `prescription_no`,
                    label: `处方单号`,
                    isListable: true
                },
                {
                    type: `remoteselect`,
                    prop: `anes_doctor`,
                    label: `麻醉医生`,
                    width: `140`,
                    isListable: true,
                    searchable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `print_status`,
                    label: `打印情况`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `print_person`,
                    label: `打印人`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `print_time`,
                    label: `打印时间`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `drugallergy`,
                    label: `药物过敏试验`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `select`,
                    prop: `status`,
                    label: `单据状态`,
                    isListable: me.invalidPrescriptionConfig == `1`,
                    options: this.prescription_status || []
                },
                {
                    type: `string`,
                    prop: `modify_date`,
                    label: `作废时间`,
                    isListable: me.invalidPrescriptionConfig == `1`
                },
                {
                    type: `custom`,
                    prop: `send_state`,
                    label: `发送状态`,
                    isListable: true,
                    fixed: `right`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)))
                    },
                    fixed: `right`,
                    options: function(that, { row }) {
                        if (!row.dic_drug_id || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.status == -1 && me.invalidPrescriptionConfig == `1`)) {
                            return []
                        } else {
                            return [{
                                class: `is-plain`,
                                label: `编辑`,
                                icon: ``,
                                type: `primary`,
                                emit: `GoEdit`,
                                permission: `default`
                            }]
                        }
                    }
                }
            ]
        }
    },
    mounted() {

    },
    methods: {
        GoEdit({ row, index }) {
            console.log(row)
            let menuName = `prescription`
            console.log(this.business)
            let r = _.find(this.business, { business_level: `M003`, location: menuName })
            let date = this.$moment(row.plan_time).format(`YYYY/MM/DD`)
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let url = (r && r.url) || `/`
                // 本系统页面链接，直接调用患者管理路由加载界面
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${row.surgeryId}&rdate=${date}&isOnlyShowMain=true&workbar=${r.workbar}&record_type=1`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                var w = this.screenWidth - 10
                var h = this.screenHeight - 10
                if (typeof winformMsg != `undefined`) {
                    w = w + 500
                    h = h + 400
                }
                window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
            }
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        loadPrescriptions() {
            if (!this.dic_ward_id) {
                return Promise.resolve([])
            }

            return new Promise((resolve, reject) => {
                let that = this
                let q = {
                    page: that.currentPage,
                    pageSize: that.pageSize,
                    wardId: that.dic_ward_id,
                    from: that.rdate[0],
                    to: that.rdate[1],
                    print_status: that.print_status || null,
                    drug_type: that.needPrintDrugType || null,
                    drug_name: that.drugName,
                    anes_name: that.searchValue
                }
                let req = this.myaxios.postpagination(`/api/Nursing/Prescription/GetPageByDateRange`, q)
                req.then(res => {
                    this.total = res.count
                    var data = res.data
                    let objs = data && _.map(data, d => {
                        return {
                            id: d.id,
                            patient_name: d.patient_name,
                            plan_time: d.surgery_mode.plan_time,
                            surgeryId: d.surgery_mode.id,
                            dic_drug_id: d.dic_drug_id,
                            dic_drug_name: d.drug.name,
                            spec: d.drug.spec,
                            amount: d.amount,
                            batch_no: d.batch_no,
                            dic_drug_type_id: d.dic_drug_type_id,
                            prescription_no: d.prescription_no,
                            anes_doctor: d.anes_doctor,
                            total_dose: d.total_dose,
                            add_drug_way: d.add_drug_way,
                            unit: d.unit,
                            print_status: d.print_time == null ? `未打印` : `已打印`,
                            print_time: (d.print_time && this.$moment(d.print_time).format(`YYYY-MM-DD HH:mm:ss`)) || ``,
                            print_person: d.print_person,
                            surplus_dose: d.surplus_dose, // Math.ceil(d.amount * d.drug.dose - d.total_dose),
                            remark: d.remark,
                            drugallergy: d.DrugAllergy,
                            enum_send_state: d.enum_send_state,
                            send_state: d.send_state,
                            send_time: d.send_time,
                            sender: d.sender,
                            sender_no: d.sender_no,
                            failure_reason: d.failure_reason,
                            send_return_id: d.send_return_id,
                            status: d.status,
                            modify_date: (d.status == -1 && ((d.modify_date && this.$moment(d.modify_date).format(`YYYY-MM-DD HH:mm:ss`)) || ``)) || ``,
                            class_name: d.status == -1 ? `cancelclass` : ``
                        }
                    }) || null
                    let ha = that.isHaveSearchotheranesdoctor
                    console.log(ha)
                    if (!ha) {
                        that.searchValue = that.currentUser.dic_worker_name
                        console.log(that.currentUser)
                    }

                    that.datalist = objs
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        selectionChange({ row }) {
            this.changedDrugs = _.filter(row, drug => {
                return drug.dic_drug_id
            })

            this.ischecked = this.changedDrugs.length != 0
        },
        // 单独抽取了一个保存方法
        Save(data) {
            return new Promise((resolve, reject) => {
                let updateData = _.filter(data, d => {
                    return d.id && d.id != undefined && d.enum_send_state != 1 && d.enum_send_state != 2
                }).map(d => {
                    return {
                        id: d.id,
                        add_drug_way: d.add_drug_way,
                        amount: d.amount,
                        batch_no: d.batch_no,
                        dic_drug_id: d.dic_drug_id.value || d.dic_drug_id,
                        dic_drug_type_id: d.dic_drug_type_id,
                        prescription_no: d.prescription_no,
                        anes_doctor: d.anes_doctor == `` ? null : d.anes_doctor && d.anes_doctor.value,
                        print_person: this.currentUser && this.currentUser.dic_worker_name,
                        print_status: d.print_status,
                        print_time: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        spec: d.spec,
                        total_dose: d.total_dose,
                        unit: d.unit,
                        remark: d.remark,
                        DrugAllergy: d.drugallergy,
                        enum_send_state: d.enum_send_state,
                        send_state: d.send_state,
                        send_time: d.send_time,
                        sender: d.sender,
                        sender_no: d.sender_no,
                        failure_reason: d.failure_reason,
                        send_return_id: d.send_return_id
                    }
                })
                let req = this.myaxios.put(`/api/Nursing/Prescription/PutMany`, updateData)
                req.then(data => {
                    resolve()
                })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        printDrug(drugType) {
            let that = this
            let drugTypeId = drugType.value
            let drugTypeName = drugType.label
            let printDrugs = _.filter(this.changedDrugs, { dic_drug_type_id: drugTypeId })
            if (!this.ischecked || printDrugs.length == 0) {
                this.$message.warning(`请至少选择一项药品类型为“${drugTypeName}”的药品`)
                return
            }
            if (!drugType.PrescriptionDocKey) {
                this.$message.error(`请先配置“${drugTypeName}”处方的处方模板`)
                return
            }
            if (!drugType.PrescriptionNoGeneratorProc) {
                this.$message.error(`请先配置“${drugTypeName}”处方的处方单号生成存储过程`)
                return
            }
            let docId = this.$root.DOCUMENT[drugType.PrescriptionDocKey]
            let pids = printDrugs.map(d => d.id + `_` + d.surgeryId).toString()
            let data = _.filter(printDrugs, d => {
                return !(d.status == -1 && this.invalidPrescriptionConfig == `1`)
            })

            console.log(data)
            this.Save(data).then(() => {
                let reqGetPrintName = this.myaxios.get(`/api/AcisSystem/DocConfig/GetByCode?code=${drugType.PrescriptionDocKey}`)
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                this.myaxios
                    .all(reqGetPrintName, req2)
                    .then(([data, isShow]) => {
                        // 增加判断，如果配置区域打印机且为当前区域则按区域打印机进行赋值
                        let printerName = data && data.default_printer_name
                        if (that.active_ward && that.active_ward.value && data && data.default_printer_name_by_ward) {
                            console.log(that.active_ward.value, data.default_printer_name_by_ward)
                            let wardPrinterNames = eval(
                                `(` + data.default_printer_name_by_ward + `)`
                            )
                            var wardRow = _.find(wardPrinterNames, x => x.ward == that.active_ward.value)
                            if (wardRow && wardRow.printer_name) {
                                printerName = wardRow && wardRow.printer_name
                            }
                        }
                        if (printerName) {
                            this.$store.dispatch(`PRINT_PDF_MehealthAgreement`, {
                                host: this.$root.DOCSERVICE_BASE,
                                params: Object.assign(
                                    {
                                        docid: docId,
                                        id1: ``,
                                        objId: pids,
                                        default_printer_name: printerName
                                    },
                                    { isShowSendPrintMessage: isShow.value }
                                )
                            })
                        } else {
                            this.$store.dispatch(`PRINT_PDF`, {
                                host: this.$root.DOCSERVICE_BASE,
                                params: Object.assign(
                                    {
                                        docid: docId,
                                        id1: ``,
                                        objId: pids
                                    },
                                    { isShowSendPrintMessage: isShow.value }
                                )
                            })
                        }

                        this.loadPrescriptions()
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        ExportExcel() {
            let that = this
            if (that.getPrescriptionProc && that.getPrescriptionProc != ``) {
                // 打印状态 处方类型 麻醉医生 药品名称
                let searchInfo = {
                    procName: that.getPrescriptionProc,
                    wardId: that.dic_ward_id,
                    from: that.$moment(that.rdate[0]).format(`YYYY-MM-DD`),
                    to: that.$moment(that.rdate[1]).add(1, `days`).format(`YYYY-MM-DD`),
                    isPrint: ((that.print_status && that.print_status == `已打印`) ? 1 : 0) || -1,
                    drugType: that.needPrintDrugType || 0,
                    anesName: that.searchValue || ``,
                    drugName: that.drugName || ``
                }
                this.myaxios.post(`/api/Nursing/Prescription/GetPrescriptionForExport`, searchInfo).then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    that.myaxios.export_excel(data, `处方管理.xls`)
                })
                    .catch(e => {
                        that.$message.error(`请检查存储过程配置是否正确`)
                    })
            } else {
                that.$message.warning(`请先配置处方导出参数：GetPrescriptionProc`)
            }
        }
    },
    watch: {
        rdate: function() {
            this.loadPrescriptions()
        },
        dic_ward_id: function() {
            this.loadPrescriptions()
        },
        print_status: function() {
            this.loadPrescriptions()
        },
        searchValue: function() {
            this.loadPrescriptions()
        },
        needPrintDrugType: function() {
            this.loadPrescriptions()
        },
        drugName: function() {
            this.loadPrescriptions()
        }
    }
}
</script>
<style lang="less">
.cancelclass {
    color: red;
    text-decoration: line-through red !important;
}
.cancelclass .ellipsis {
    color: red;
    text-decoration: line-through red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PrescriptionManage/Index.vue